import { useEffect } from 'react';
import { useApolloClient } from '@apollo/client';
import { useUser } from '../../contexts/ssr-user-context';
import UPDATE_USER_UTM_INFO from '../../gql/mutations/update-user-utm-info.gql';
import {
  isAttributionEligibleHost,
  hasUtmMutationSucceeded,
  buildUtmMutationPayload,
  markUtmMutationSucceeded,
} from '../../utils/marketing-attribution';

export default function UtmSyncOnLogin() {
  const client = useApolloClient();
  const { user } = useUser();

  useEffect(() => {
    if (typeof window === 'undefined') return;
    const { hostname } = window.location;
    if (!isAttributionEligibleHost(hostname)) return;
    if (!user?.id) return;
    if (hasUtmMutationSucceeded()) return;

    const payload = buildUtmMutationPayload();
    if (!payload) return;

    (async () => {
      try {
        await client.mutate({
          mutation: UPDATE_USER_UTM_INFO,
          variables: {
            userUtmInfo: payload,
          },
        });
        markUtmMutationSucceeded();
      } catch (error) {
        // eslint-disable-next-line no-console
        console.error('Failed to sync UTM info:', error);
      }
    })();
  }, [client, user]);

  return null;
}
